module.exports = __webpack_public_path__ + "img/Slipmat Purple.89fbd238.png";